/**
 * The /badges page.
 */
import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import {compose} from "mu-lambda";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {
    enums,
    withConversionContext,
    withMarkConversion,
    type PartialLearningTimeInfo,
    type WithMarkConversionProps,
    type WithoutMarkConversion,
} from "@khan/analytics-learning-time";
import {mediaQueries} from "@khan/shared-styles";

import PageRoot from "#app-shell-package/page-root.tsx";
import withRouter, {
    type WithoutRouter,
    type WithRouterProps,
} from "#data-access/with-router.ts";

import BadgesView from "./badges-view.tsx";
import {withStrings} from "./locales/badges-page/load-strings.tsx";

type Props = WithMarkConversionProps & WithRouterProps;

class BadgesPage extends React.Component<Props> {
    componentDidMount() {
        const {markConversion} = this.props;
        markConversion({id: "badges_page_visit"});
    }

    render(): React.ReactNode {
        // @ts-expect-error - TS2339 - Property 'slug' does not exist on type '{}'.
        const {slug} = this.props.match.params;

        // NOTE(jvoll): We don't want to index the individual badge highlight
        // badges. I'm unsure why but this was existing behaviour I've copied
        // as we move this page into devshell.
        return (
            <PageRoot settings={{title: t`Badges`, noIndex: !!slug}}>
                <View style={styles.page}>
                    <View style={styles.container}>
                        <BadgesView kaid="" spotlightBadgeSlug={slug} />
                    </View>
                </View>
            </PageRoot>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: 1200,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 32,
        paddingTop: 32,
        margin: "auto",
        backgroundColor: color.white,

        [mediaQueries.lgOrSmaller]: {
            width: "100%",
        },

        [mediaQueries.smOrSmaller]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    page: {
        backgroundColor: color.white,
        width: "100%",
    },
});

type ExportProps = WithoutMarkConversion<
    WithoutRouter<
        JSX.LibraryManagedAttributes<
            typeof BadgesPage,
            React.ComponentProps<typeof BadgesPage>
        >
    >
>;

const mapPropsToLearningTime = (): PartialLearningTimeInfo => {
    return {
        activity: enums.Activity.OTHER_ACTIVITY,
        product: enums.Product.OTHER_PRODUCT,
    };
};

export default compose(
    withStrings,
    withRouter,
    withConversionContext(mapPropsToLearningTime),
    withMarkConversion,
)(BadgesPage) as React.ComponentType<ExportProps>;
